module.exports = __webpack_public_path__ + "img/settings3.32c9d8a4.png";